<template>
  <div>
    <h1>Camera Mechanics</h1>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "SEO Test | Camera Mechanics",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "이 페이지는 babylonejs의 Camera Mechanics 연습입니다.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
